
export const TranslationMode = {
  xOnly: 1,
  yOnly: 2,
  zOnly: 3,
  all: 4,
};
